/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBSTREAM = 'GETCLUBSTREAM'
export const GETCLUBWALLETS = 'GETCLUBWALLETS'


// WEBPACK FOOTER //
// ./src/containers/ClubStream/constants.js